<template>
  <transition name="eu-slide-fade-left">
    <div v-show="animate" :class="[classList]">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'EmdCommunication',
  data () {
    return {
      animate: true
    }
  },
  props: {
    color: {
      type: String,
      required: false,
      default: null,
      validator: (value) => {
        return ['primary', 'secondary', 'tertiary', 'success', 'danger', 'info', 'warning', 'subtle', 'pagarme', null].includes(value)
      }
    }
  },
  computed: {
    classList () {
      var classList = []
      if (this.color) {
        classList.push(`_color_${this.color}`)
      }
      if (this.contrast) {
        classList.push('_type_contrast')
      }
      return classList
    }
  }
}
</script>
